import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CON001_Request,
  IAPI_CON001_Response,
  IAPI_MAI001_Request,
  IAPI_MAI001_Response,
  IAPI_MAI003_Request,
  IAPI_MAI003_Response,
} from "../../../type/apiType";

/**
 * メール参照API
 * @return httpAPI_MAI001
 */
const httpAPI_MAI001 = async (
  param: IAPI_MAI001_Request
): Promise<IAPI_MAI001_Response> => {
  let res = await http.post(ApiUrl.API_MAI001, {
    ...param,
  });

  return res.data;
};

/**
 * メール更新API
 * @return httpAPI_MAI003
 */
const httpAPI_MAI003 = async (
  param: IAPI_MAI003_Request
): Promise<IAPI_MAI003_Response> => {
  let res = await http.post(ApiUrl.API_MAI003, {
    ...param,
  });

  return res.data;
};

/**
 * 契約者一覧参照API
 * @return httpAPI_CON001
 */
const httpAPI_CON001 = async (
  param: IAPI_CON001_Request
): Promise<IAPI_CON001_Response> => {
  let res = await http.post(ApiUrl.API_CON001, {
    ...param,
  });

  return res.data;
};

export { httpAPI_MAI001, httpAPI_MAI003, httpAPI_CON001 };
